<template>
  <div id="dashboard" class="flex-container">
    <template v-if="currentPort.status != 3">
      <!-- NPS trigger -->
      <div
        class="announcement-alt flex-max"
        v-if="
          (style=='vm' || style=='bvs')
          && $store.state.nps
          && new Date($store.state.nps) < new Date(new Date().setDate(new Date().getDate()-61))
        "
      >
        <span>
          <awesomeIcon icon="question-circle" /> <strong>Hoe beoordeelt u ons? </strong>
          Met een 10 beoordeelt u ons goed. Dank voor uw reactie.
          <button
            @click="addNps(-1)"
            style="float: right;width: 55px;margin: 0px 2px 0px 0px;"
          >
            <strong>X</strong>
          </button>
        </span>
        <div style="float: left; padding-top: 4px;">
          <button @click="addNps(1)" class="tertiary" style="width: 55px;margin-right: 2px;">
            1</button>
          <button @click="addNps(2)" class="tertiary" style="width: 55px;margin-right: 2px;">
            2</button>
          <button @click="addNps(3)" class="tertiary" style="width: 55px;margin-right: 2px;">
            3</button>
          <button @click="addNps(4)" class="tertiary" style="width: 55px;margin-right: 2px;">
            4</button>
          <button @click="addNps(5)" class="tertiary" style="width: 55px;margin-right: 2px;">
            5</button>
          <button @click="addNps(6)" class="tertiary" style="width: 55px;margin-right: 2px;">
            6</button>
          <button @click="addNps(7)" class="tertiary" style="width: 55px;margin-right: 2px;">
            7</button>
          <button @click="addNps(8)" class="tertiary" style="width: 55px;margin-right: 2px;">
            8</button>
          <button @click="addNps(9)" class="tertiary" style="width: 55px;margin-right: 2px;">
            9</button>
          <button @click="addNps(10)" class="tertiary" style="width: 55px;margin-right: 2px;">
            10
          </button>
        </div>

      </div>

      <!-- Year trigger intake -->
      <div
        class="announcement-alt flex-max"
        v-if="
          currentPort
          && currentPort.status != 3
          && (currentPort.brand=='Doelbeleggen' || currentPort.brand=='OXBY')
          && new Date(currentPort.date) > new Date(new Date().setDate(new Date().getDate()-7))
          && intakeDateyear < (new Date()) && !find(intakes, { port })
        "
      >
        <div>
          <awesomeIcon icon="exclamation-circle" /> Op {{
            (new Date(currentPort.intake_date)).toLocaleDateString()
          }} heeft u voor het laatst uw situatie aan ons doorgegeven, is er sindsdien iets aan uw
          (financiële) situatie veranderd?
        </div>
        <button @click="noChanges" class="tertiary">
          <awesomeIcon icon="times"/> Nee
        </button>
        <button @click="redo" class="tertiary" style="margin-right:20px;">
          <awesomeIcon icon="check"/> Ja
        </button>
      </div>

      <modalWindow
        v-show="intakeReminder" @close="intakeReminder=false" width="300"
        :bgtrigger="false" class="intakereminder" overflow="hidden"
      >
        <div class="leadimage">
          <awesomeIcon icon="tasks"/>
        </div>
        <p>Uw klantprofiel is onvolledig. Deze melding verdwijnt nadat u alle vragen
        heeft beantwoord en opgeslagen.</p>
        <div class="button" @click="continueIntake(port)">
          <awesomeIcon icon="user"/> Naar klantprofiel
        </div>
        <div
          v-if="intakeStart === 'user'"
          class="block-button"
          @click="stopIntake(find(intakes, { port }))"
        >
          <awesomeIcon icon="trash"/> Intake verwijderen
        </div>
      </modalWindow>

      <modalWindow
        v-show="newIbanReminder" @close="newIbanReminder=false" width="300"
        :bgtrigger="false" class="intakereminder" overflow="hidden"
      >
        <div class="leadimage">
          <awesomeIcon icon="money-check"/>
        </div>
        <p>Uw iban is gewijzigd, hier dient nog een identificatiestorting voor gemaakt te worden.
          Deze melding verdwijnt nadat er een identificatiestorting plaats gevonden heeft.
        </p>
        <div class="button" @click="continueIntake(port)">
          <awesomeIcon icon="user"/> Naar identificatiestorting
        </div>
      </modalWindow>

      <!-- Alert value reached -->
      <div
        class="announcement-alt flex-max"
        v-if="
          currentPort
          && currentPort.brand=='Doelbeleggen'
          && currentPort.sat
          && currentPort.alert > currentPort.sat.score
          && currentPort.alert != 0
        "
      >
        <span>
          <awesomeIcon icon="exclamation-circle" />
          Uw alertwaarde is bereikt{{
            [8, 10, 12].includes(currentPort.type)
            ? '.'
            : ', welke actie wilt u ondernemen?'
          }}
        </span>
        <button class="tertiary" @click="$refs.scoreWidget.editScore=true">
          <awesomeIcon icon="bell"/> Alertwaarde aanpassen
        </button>
        <button
          v-if="![8, 10, 12].includes(currentPort.type) && !find(intakes, { port })"
          @click="redo"
          class="tertiary" style="margin-right:20px;"
        >
          <awesomeIcon icon="fa-regular fa-circle-dot" /> Doel wijzigen
        </button>
      </div>

    </template>

    <!-- alerts -->
    <!-- Goal alerts (only OXBY) -->
    <div v-if="Number(currentPort.status) !== 3">
      <oxbyGoalAlertsWidget
        v-if="currentPort.brand === 'OXBY'"
        :currentPort="currentPort"
      />
      <!-- Startgoal alerts -->
      <startGoalAlertsWidget
        v-if="currentPort.target > 0 && currentPort.brand === 'Doelbeleggen'"
        :currentPort="currentPort"
      />

      <!-- Birthday alerts -->
      <birthdayAlertsWidget
        v-if="
          currentPort.brand === 'Doelbeleggen'
          && currentPort.birthday
          && currentPort.birthday !== '0000-00-00 00:00:00'
          && Number(currentPort.type) === 3
        "
        :currentPort="currentPort"
      />
      <!-- AOW alerts -->
      <aowAlertWidget
        v-if="
          currentPort.brand === 'Doelbeleggen'
          && currentPort.birthday
          && currentPort.birthday !== '0000-00-00 00:00:00'
          && [7,9,11].includes(Number(currentPort.type))
        "
        :currentPort="currentPort"
      />
    </div>
    <template v-if="positions !== null">
      <template v-if="Object.keys(positions).length == 0">
        <p class="msg">Nog geen data!</p>
      </template>
      <template v-else-if="
        (
          new Date(currentPort.date) <= new Date(new Date().setDate(new Date().getDate()-7))
          && currentPort.bank !== 'GIRO'
          && currentPort.bank !== 'BAL'
        ) || (
          currentPort.status == 3 && currentPort.value < 1
        )
      ">
        <p class="msg">
          Portefeuille gesloten
        </p>
        <reportsWidget/>
      </template>
      <template v-else>
        <p
          v-if="
            currentPort.value >= 1 && Object.keys(positions).length > 2
            && currentPort.status == 3
          "
          class="msg"
        >
          Portefeuille bezig met verkopen stukken
        </p>
        <p v-else-if="currentPort.value >= 1 && currentPort.status == 3" class="msg">
          Portefeuille bezig met overmaken naar tegenrekening
        </p>
        <!-- widgets row 1 -->
        <goalWidget
          :watch="deposit"
          class="flex-100"
          ref="scoreWidget"
          v-if="currentPort.brand == 'Doelbeleggen'"
        />
        <template v-else>
          <totalWidget :watch="deposit" class="flex-grow" />
          <sectorWidget class="flex-33" />
          <classWidget class="flex-33" />
        </template>
        <!-- widgets row 2 -->
        <projectWidget
          class="flex-100"
          v-if="currentPort.brand == 'Doelbeleggen'"
        />
        <!-- payout widget -->
        <payoutWidget
          v-if="$store.state.role > 7 && payout && payout.cashflow && payout.cashflow.length"
          class="flex-100"
        />
        <!-- widgets row 3 -->
        <topWidget
          class="flex-66"
        />
        <changeGoalWidget
          class="flex-33"
          v-if="
            currentPort.brand == 'OXBY'
            || currentPort.brand == 'Doelbeleggen'
          "
        />
        <!-- widgets row 5 -->
        <classWidget
          class="flex-33"
          v-if="currentPort.brand == 'Doelbeleggen'"
        />
        <currencyWidget
          v-else
          class="flex-33"
        />
        <timeWidget
          class="flex-grow"
        />
        <!-- widgets row 6 -->
        <classTimeWidget
          class="flex-100"
          v-if="currentPort.brand!='Doelbeleggen'"
        />
        <scoresWidget
          class="flex-100"
          v-if="currentPort.brand == 'Doelbeleggen'"
        />
        <deltasWidget
          class="flex-100"
          v-if="currentPort.brand == 'Doelbeleggen' && deltas.length > 1 && $store.state.role > 7"
        />
        <!-- widgets row 6 -->
        <twoFactorWidget
          class="flex-33"
          v-if="!$store.state.twoFactor"
        />
        <mutationsWidget :class="[!$store.state.twoFactor ? 'flex-66' : 'flex-grow']"/>
        <!-- widgets row 7 -->
        <reportsWidget class="flex-grow" />
        <annualSpaceWidget
          class="flex-33"
          v-if="
            currentPort.type === 7
            || currentPort.type === 9
            || currentPort.type === 11
          "
        />
      </template>
    </template>
    <div v-else class="loader"></div>
  </div>
</template>

<script>
import {
  each,
  sumBy,
  find,
  groupBy,
  filter,
  map,
} from 'lodash-es';

import annualSpaceWidget from './widgets/annualSpace';
import timeWidget from './widgets/time';
import totalWidget from './widgets/total';
import topWidget from './widgets/top';
import classWidget from './widgets/class';
import changeGoalWidget from './widgets/changeGoal';
import sectorWidget from './widgets/sector';
import currencyWidget from './widgets/currency';
import classTimeWidget from './widgets/classTime';
import deltasWidget from './widgets/deltasTime';
import mutationsWidget from './widgets/mutations';
import reportsWidget from './widgets/reports';
import goalWidget from './widgets/goal';
import scoresWidget from './widgets/scoresTime';
import twoFactorWidget from './widgets/twoFactor';
import projectWidget from './widgets/project';
import aowAlertWidget from './alerts/aowAlerts';
import birthdayAlertsWidget from './alerts/birthdayAlerts';
import oxbyGoalAlertsWidget from './alerts/oxbyGoalAlerts';
import startGoalAlertsWidget from './alerts/startGoalAlerts';
import payoutWidget from './widgets/payouts';

export default {
  name: 'UserDashboard',
  components: {
    annualSpaceWidget,
    timeWidget,
    totalWidget,
    topWidget,
    classWidget,
    deltasWidget,
    sectorWidget,
    currencyWidget,
    classTimeWidget,
    mutationsWidget,
    reportsWidget,
    goalWidget,
    scoresWidget,
    projectWidget,
    changeGoalWidget,
    twoFactorWidget,
    aowAlertWidget,
    birthdayAlertsWidget,
    oxbyGoalAlertsWidget,
    startGoalAlertsWidget,
    payoutWidget,
  },
  data() {
    return {
      deltas: [],
      deposit: false,
      style: process.env.VUE_APP_STYLE,
      payout: {},
      positions: null,
      mutations: [],
      scores: [],
      files: [],
      totals: [],
      totalsAsset: [],
      totalsRisk: [],
      intakeReminder: false,
      intakeStart: null,
      newIbanReminder: false,
    };
  },
  computed: {
    port() {
      return this.$store.state.currentPort;
    },
    currentPort() {
      return find(this.$store.state.ports, {
        id: this.$store.state.currentPort,
      });
    },
    intakes() {
      if (
        this.currentPort.brand !== 'Doelbeleggen'
        && this.currentPort.brand !== 'OXBY'
      ) {
        return [];
      }
      return this.$store.state.intakes;
    },
    intakeDateyear() {
      const date = new Date(this.currentPort ? this.currentPort.intake_date : null);
      date.setFullYear(date.getFullYear() + 1);
      return date;
    },
  },
  watch: {
    port() {
      this.getPositions();
    },
  },
  created() {
    if (this.$store.state.currentPort) {
      this.intakeCheck();
      this.getPositions();
      if (this.$store.state.role > 7) {
        this.getDailyDelta();
        this.getPayouts();
      }
    }
  },
  methods: {
    find,
    getPayouts() {
      this.sdk.getPayouts(this.$store.state.currentPort, (response) => {
        if (response.status === 200 && response.data[0]) {
          const tempCashflow = map(
            filter(
              JSON.parse(response.data[0].cashflow),
              (o) => Number(o.payout) > 0,
            ),
            (o) => {
              const temp = o.date.split('-');
              o.fixedDate = `${temp[2]}-${temp[1]}-${temp[0]}`;
              return o;
            },
          );
          this.payout = {
            calc_interest: response.data[0].calc_interest,
            cashflow: tempCashflow,
            forehand: response.data[0].forehand,
            frequency: response.data[0].frequency,
            initials: response.data[0].initials,
            interest: response.data[0].interest,
            lastpayout_date: response.data[0].lastpayout_date,
            overtimes: response.data[0].overtimes,
            payouts: response.data[0].payouts,
            port: response.data[0].port,
            revision: response.data[0].revision,
            start_date: response.data[0].start_date,
            years: response.data[0].years,
          };
        }
      });
    },
    getDailyDelta() {
      this.sdk.getDailyDelta(this.$store.state.currentPort, (response) => {
        if (response.status === 200) {
          let year = 0;
          for (let i = 0; i < response.data.length; i += 1) {
            this.deltas.push([
              new Date(response.data[i].date),
              this.formatPrice((this.deltas[i - 1]
              && year === new Date(response.data[i].date).getFullYear()
                ? this.deltas[i - 1][1] : 100)
                * (1 + (response.data[i].delta_daily / 100)), true),
            ]);
            year = new Date(response.data[i].date).getFullYear();
          }
        }
      });
    },
    redo() {
      this.$store.state.confirm.toggle({
        text: 'U opent uw klantprofiel om wijzigingen door te voeren.\n\nKijk voor de zekerheid nog even naar het overzicht.\n\nWellicht zijn er nog zaken die uw aandacht nodig hebben.',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.redoIntake(this.port, (response) => {
              window.location.href = `?intake=${response.data.intake}`;
            });
          }
        },
      });
    },
    stopIntake(intake) {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u deze herintake wilt verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteIntake(intake.id, () => {
              this.sdk.getIntakes((response) => {
                this.$store.state.intakes = response.data;
              });
            });
            this.intakeReminder = false;
          }
        },
      });
    },
    continueIntake(port) {
      const intake = find(this.intakes, { port });
      if (intake) {
        window.location.href = `?intake=${intake.id}`;
      } else {
        this.redo();
      }
    },
    intakeCheck() {
      const intake = find(
        this.intakes,
        (o) => o.port === this.$store.state.currentPort
          && (
            o.status === 'Bezig'
            || (
              o.status === 'Ingeleverd'
              && Number(o.value) === 0
              && JSON.parse(o.intake).goalData.vtrChanged
            )
          ),
      );
      if (intake) {
        if (intake.status === 'Bezig') {
          this.intakeReminder = true;
        } else {
          this.newIbanReminder = true;
        }
        this.intakeStart = JSON.parse(intake.admin).start;
      }

      if (this.$store.state.currentPort
        && this.currentPort.action_required
        && this.currentPort.brand !== 'VMVB'
        && this.currentPort.brand !== 'BVS'
      ) {
        this.intakeReminder = true;
      }
    },
    noChanges() {
      this.currentPort.intake_date = new Date();
      this.sdk.modifyPort(
        this.$store.state.currentPort,
        null,
        null,
        new Date(),
        () => {},
      );
    },
    addNps(score) {
      this.$store.state.nps = null;
      this.sdk.addNps(
        score,
        () => {},
      );
    },
    clickDetails(grouping) {
      this.$store.state.currentView = 'Positions';
      this.$store.state.currentPortGrouping = grouping;
    },
    getRows(grouping, negatives = true) {
      const results = [];
      each(groupBy(this.positions, grouping), (rows, category) => {
        const amount = sumBy(rows, 'worth');
        let c = category;
        if (grouping === 'currency') {
          c = `${category} (€${this.formatPrice(rows[0].currency_rate)})`;
        }
        results.push([c, negatives && amount < 0 ? 0 : amount]);
      });
      return results;
    },
    getDateOfISOWeek(w, y) {
      const simple = new Date(y, 0, 1 + (w - 1) * 7);
      const dow = simple.getDay();
      const ISOweekStart = simple;
      if (dow <= 4) {
        ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
      } else {
        ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
      }
      return ISOweekStart;
    },
    getPositions() {
      this.positions = null;
      this.totals = [];
      this.totalsAsset = [];
      this.mutations = [];
      this.scores = [];
      this.sdk.getScores(this.$store.state.currentPort, (response) => {
        if (response.status === 200) {
          const temp = [];
          for (let i = 0; i < response.data.length; i += 1) {
            temp.push([
              this.getDateOfISOWeek(
                response.data[i].period.toString().substr(4),
                response.data[i].period.toString().substr(0, 4),
              ),
              Math.min(response.data[i].score, 99),
              this.currentPort.alert,
            ]);
          }
          this.scores = temp.reverse();
        }
      });
      this.sdk.getPositions(this.$store.state.currentPort, null, (response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            if (
              response.data[i].original_class === 'Obligaties'
              && new RegExp('^([0-9],[0-9][0-9][0-9]%|FRN)').test(response.data[i].name)
            ) {
              response.data[i].obli = true;
            }

            if (!response.data[i].sector) {
              response.data[i].sector = 'Overige';
            }
            if (response.data[i].name === response.data[i].currency) {
              response.data[i].purchase_rate = response.data[i].rate;
            }
            response.data[i].worth = (
              response.data[i].quantity * response.data[i].rate
            );
            response.data[i].purchaseCost = (
              response.data[i].quantity * response.data[i].purchase_rate
            );
            response.data[i].result = (
              response.data[i].worth - response.data[i].purchaseCost
            );
          }
          this.positions = response.data;
          this.sdk.getTransactions(this.$store.state.currentPort, (mutresponse) => {
            let firstDate = null;
            if (mutresponse.status === 200) {
              this.mutations = mutresponse.data.results;
              this.sdk.getPerformance(this.$store.state.currentPort, (perfresponse) => {
                if (perfresponse.status === 200 && perfresponse.data.length > 0) {
                  const temp = [];
                  const temp2 = [];
                  const temp3 = [];
                  let totalInvest = 0;

                  for (let i = 0; i <= perfresponse.data.length; i += 1) {
                    if (firstDate === null) {
                      firstDate = new Date(perfresponse.data[i].date);
                      firstDate.setMonth(firstDate.getUTCMonth() - 3);
                      firstDate = firstDate.toISOString();
                    }

                    const from = i !== 0
                      ? perfresponse.data[i - 1].date
                      : firstDate;

                    let date = new Date();
                    let till = date.toISOString();
                    if (i !== perfresponse.data.length) {
                      till = perfresponse.data[i].date;
                      date = new Date(till);
                    }

                    const total = sumBy(
                      filter(this.mutations, (obj) => [1, 18, 19, 21, 22].includes(obj.superclass)
                        && (obj.class === 'Storting' || obj.class === 'Deponering')
                        && !obj.storno
                        && obj.date >= from && obj.date < till),
                      'total',
                    )
                    - sumBy(
                      filter(this.mutations, (obj) => [1, 18, 19, 21, 22].includes(obj.superclass)
                      && (obj.class === 'Opname' || obj.class === 'Lichting')
                      && !obj.storno
                      && obj.date >= from && obj.date < till),
                      'total',
                    );

                    totalInvest += total;

                    let index = null;
                    if (date.getMonth() === 11) {
                      index = `Q4 ${date.getFullYear()}`;
                    } else if (date.getMonth() > 7) {
                      index = `Q3 ${date.getFullYear()}`;
                    } else if (date.getMonth() > 4) {
                      index = `Q2 ${date.getFullYear()}`;
                    } else if (date.getMonth() > 1) {
                      index = `Q1 ${date.getFullYear()}`;
                    } else {
                      index = `Q4 ${date.getFullYear() - 1}`;
                    }

                    // lijn toevoegen met stortingen en deponeringen (voor mijzelf (totalInvest)
                    if (i !== perfresponse.data.length) {
                      temp.push([
                        index,
                        perfresponse.data[i].worth,
                        true,
                        total,
                        totalInvest,
                      ]);

                      const properties = Object.keys(perfresponse.data[i]);
                      for (let key = 0; key < properties.length; key += 1) {
                        if (perfresponse.data[i][properties[key]] <= 0) {
                          // eslint-disable-next-line
                          perfresponse.data[i][properties[key]] = null;
                        }
                      }

                      temp2.push([
                        index,
                        perfresponse.data[i].aandelen_worth,
                        perfresponse.data[i].alternatieve_beleggingen_worth,
                        perfresponse.data[i].converteerbare_obligaties_worth,
                        perfresponse.data[i].liquiditeiten_worth,
                        perfresponse.data[i].geldmarkt_worth,
                        perfresponse.data[i].obligaties_worth,
                        perfresponse.data[i].overige_worth,
                        perfresponse.data[i].opties_worth,
                        perfresponse.data[i].vastgoed_worth,
                        perfresponse.data[i].beschermd_beleggen_worth,
                        perfresponse.data[i].samengestelde_obligaties_worth,
                      ]);

                      temp3.push([
                        index,
                        perfresponse.data[i].liquiditeiten_worth
                          + perfresponse.data[i].geldmarkt_worth,
                        perfresponse.data[i].obligaties_worth
                          + perfresponse.data[i].converteerbare_obligaties_worth
                          + perfresponse.data[i].samengestelde_obligaties_worth,
                        perfresponse.data[i].beschermd_beleggen_worth,
                        perfresponse.data[i].aandelen_worth
                          + perfresponse.data[i].alternatieve_beleggingen_worth
                          + perfresponse.data[i].vastgoed_worth,
                        perfresponse.data[i].overige_worth
                          + perfresponse.data[i].opties_worth,
                      ]);
                    } else {
                      const worth = sumBy(this.positions, 'worth');
                      temp.push([
                        (new Date(this.positions[0].date)).toLocaleDateString(),
                        worth,
                        false,
                        total,
                        totalInvest,
                      ]);
                    }
                  }
                  this.totals = temp;
                  this.totalsAsset = temp2;
                  this.totalsRisk = temp3;
                } else {
                  const temp = [];
                  const date = new Date();
                  let index = null;
                  if (date.getMonth() >= 9) {
                    index = `Q3 ${date.getFullYear()}`;
                  } else if (date.getMonth() >= 6) {
                    index = `Q2 ${date.getFullYear()}`;
                  } else if (date.getMonth() >= 3) {
                    index = `Q1 ${date.getFullYear()}`;
                  } else {
                    index = `Q4 ${date.getFullYear() - 1}`;
                  }
                  // geen performance
                  const total = sumBy(
                    filter(this.mutations, (obj) => [1, 18, 19, 21, 22].includes(obj.superclass)
                      && (obj.class === 'Storting' || obj.class === 'Deponering')
                      && !obj.storno),
                    'total',
                  )
                  - sumBy(
                    filter(this.mutations, (obj) => [1, 18, 19, 21, 22].includes(obj.superclass)
                    && (obj.class === 'Opname' || obj.class === 'Lichting')
                    && !obj.storno),
                    'total',
                  );
                  temp.push([
                    index,
                    0,
                    true,
                    0,
                    0,
                  ]);
                  temp.push([
                    (new Date(this.positions[0].date)).toLocaleDateString(),
                    sumBy(this.positions, 'worth'),
                    false,
                    total,
                    total,
                  ]);
                  this.totals = temp;
                }
              });
            } else {
              this.sdk.logout();
              window.location.reload();
            }
          }, '', '', -1);
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
      this.sdk.getFiles(this.$store.state.currentPort, (response) => {
        if (response.status === 200) {
          const nameResolve = (file) => {
            if (file.date.length === 6) {
              if (file.date[4] === 'Q') {
                return new Date(
                  file.date.substring(0, 4),
                  (parseInt(file.date.substring(5, 6), 10) - 1) * 3,
                  2,
                );
              }
              return new Date(
                file.date.substring(0, 4),
                parseInt(file.date.substring(4, 6), 10) - 1,
                1,
              );
            }
            if (file.date.length === 4) {
              return new Date(
                file.date.substring(0, 4),
                11,
                31,
              );
            }
            return new Date(0);
          };
          response.data.sort((a, b) => {
            if (nameResolve(a) < nameResolve(b)) {
              return 1;
            }
            if (nameResolve(a) > nameResolve(b)) {
              return -1;
            }
            return 0;
          });

          for (let i = 0; i < response.data.length; i += 1) {
            response.data[i].realDate = nameResolve(response.data[i]);
            response.data[i].year = response.data[i].date.substring(0, 4);
            // if (!this.year) {
            //   this.year = response.data[i].date.substring(0, 4);
            // }
          }

          this.files = response.data;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// .flex-container {
//   column-gap: 20px;
//   @media #{$mobile} {
//     row-gap: 10px;
//     padding: 10px;
//   }
//   @media #{$desktop} {
//     margin: 20px 0;
//     row-gap: 20px;
//   }
// }
.dashboard-card {
  margin: 5px;
}
// nested flex-container fix
.flex-container > .flex-container {
  margin: 0;
  padding: 0;
}
.intakereminder {
  p { margin: 20px; }
  .button {
    margin: 20px;
    display: block;
    height: initial;
  }
  .block-button {
    border-top: 1px solid #0003;
    cursor: pointer;
  }
  .leadimage {
    width:100%;
    background-color: $color-highlight;
    padding:30px 20px;
    box-sizing:border-box;
    svg {
      display:block;
      height:70px;
      width:70px;
      color: darken($color-highlight, 20%);
      margin:0px auto;
    }
  }
}
</style>
